angular.module('rxrefills').config(['AppRoutesProvider', '$stateProvider',
    function (AppRoutesProvider, $stateProvider) {
        'use strict';

        var portalSettings = { toolbarItem: 'prescriptions' };

        var appRoutes = {
            'rxrefill': {
                state: 'rxrefill',
                route: '/rxrefill/',
                portalSettings: portalSettings
            },
            'prescriptions': {
                state: 'prescriptions',
                route: '/prescriptions',
                portalSettings: portalSettings
            },
            'prescriptionsMobile': {
                state: 'prescriptionsMobile',
                route: '/prescriptionsMobile',
                portalSettings: portalSettings
            }
        };

        AppRoutesProvider.setupAppRoutes(appRoutes);

        $stateProvider
            .state(appRoutes.rxrefill.state, {
                url: appRoutes.rxrefill.route,
                templateUrl: '/rxrefills/views/rxrefills.html',
                controller: 'RxRefillCtrl',
                description: '/RxRefill',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('RxRefills'); }
                }
            })
            .state(appRoutes.prescriptions.state, {
                url: appRoutes.prescriptions.route,
                templateUrl: '/rxrefills/views/prescriptions.html',
                controller: 'RxRefillCtrl',
                description: '/prescriptions',
                resolve: {
                    $title: function (gettextCatalog) { return gettextCatalog.getString('RxRefills'); }
                }
            })
            .state(appRoutes.prescriptionsMobile.state, {
                url: appRoutes.prescriptionsMobile.route,
                templateUrl: '/rxrefills/views/prescriptions.html',
                resolve: {
                    isMobile: function() { return true; },
                    $title: function (gettextCatalog) { return gettextCatalog.getString('RxRefills'); }
                },
                controller: 'RxRefillMobileCtrl',
                description: appRoutes.prescriptionsMobile.route
            });

    }]);